module.exports = __webpack_public_path__ + "img/10979920_L.18cda7d5.png";